import { isMobileOnly, isFirefox, isChrome, isChromium, browserVersion, isEdge } from 'mobile-device-detect';
export default {
  data: () => ({
    isMobile : false,
    browserSupported : true,
  }),
  created(){
    this.checkEnvironment();
  },
  methods : {
    checkEnvironment(){
      this.isMobile=isMobileOnly;
      if(isFirefox || isChrome || isChromium){// || isSafari){
        this.browserSupported=true;
      }else if(isEdge && browserVersion >= 42){ //17
        this.browserSupported=true;
      }else{
        this.browserSupported=false;
      }
    }

  }
}